import { useEffect, useState } from 'react';

/**
 * Is this a phone?
 *
 * Width alone calls a narrow desktop window a phone, and touch alone calls a
 * touchscreen laptop one. A phone is both: a small screen you drive with a
 * finger, which is what actually changes the layout — side panels have nowhere
 * to go, and nothing can rely on hovering.
 *
 * Anything desktop keeps must stay outside this flag: the rule is that the
 * mobile layout is additive, so a wide screen renders exactly what it did
 * before.
 */
const PHONE = [
  '(pointer: coarse) and (max-width: 820px)',
  // A phone turned on its side is wider than it is tall and still a phone.
  '(pointer: coarse) and (max-height: 520px)',
  '(max-width: 560px)',
].join(', ');

export function useIsMobile(): boolean {
  const [mobile, setMobile] = useState(() => globalThis.matchMedia?.(PHONE).matches ?? false);

  useEffect(() => {
    const query = globalThis.matchMedia?.(PHONE);
    if (!query) return;
    const update = () => setMobile(query.matches);
    update();
    query.addEventListener('change', update);
    return () => query.removeEventListener('change', update);
  }, []);

  return mobile;
}

/** A finger rather than a pointer: no hover, so nothing may hide behind one. */
export function isTouch(): boolean {
  return globalThis.matchMedia?.('(pointer: coarse)').matches ?? false;
}
